import _ from 'lodash'

/*
  This function is used to calculate the right expense-activity rateMarkup
  based on the global rateMarkup (Saved in team collection), and
  contact rateMarkup (Saved in project collection)
  contact rateMarkup takes priority over the global rateMarkup
  global rateMarkup CAN be overriden by a contact rateMarkup of 0
*/
const getRateMarkup = (projectData, teamData) => {
  const notPresent = 'NOT_PRESENT'
  const defaultValue = 0

  const isPresent = rateMarkupValue => rateMarkupValue || rateMarkupValue === 0
  const getValueIfPresent = (rateMarkupValue, defaultValue) =>
    isPresent(rateMarkupValue) ? rateMarkupValue : defaultValue

  const contactRateMarkup = _.get(projectData, 'contact.rateMarkup', notPresent)
  const globalRateMarkup = _.get(teamData, 'defaultRateMarkup', notPresent)

  const globalOrDefault = getValueIfPresent(globalRateMarkup, defaultValue)
  const rateMarkup = getValueIfPresent(contactRateMarkup, globalOrDefault)

  return rateMarkup
}

export default getRateMarkup
